import React, {useState, useContext, useEffect} from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonButton } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

export function UploadTemplateModal(props) {

    let zasava_context = useContext(Auth_Zasava_Context);


    let [acctID, setAcctID ] = useState(zasava_context.acctID);
    let [schema, setSchemaName] = useState(zasava_context.schema);
    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    let [templateFile, setTemplateFile] = useState();


    function uploadTemplate() {

        alert("In uploadTemplate");
        alert(props.data.data_merchantID);

        let formData = new FormData();
        formData.append('Tracker', '9007');
        formData.append('user', acctID);
        formData.append('xMerchantAccountID', props.data.data_merchantID);
        formData.append('xImageID', props.data.data_templateNumber);
        formData.append('xMerchantSchemaName', props.data.data_merchantSchemaName);
        //formData.append('myFile', files[0]);
        formData.append('xMerchantInvoiceTemplate', templateFile);
        formData.append('sessionID', sessionID);                


        let requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72001B',
                user: acctID,
            })*/
        }

        fetch("https://zasava.com/ims/admin_zsava_indexApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
        })
    }


    function invoiceTemplateHandler(e) {  

        if(e.target.files == null)
        {
            setTemplateFile("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
        }
        else
        {
            setTemplateFile(e.target.files[0])
        }
    }

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        //setViewInventoryAvailableRooms([]);
        props.closeModal(event);
    }

    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal isOpen={ props.openModal }>
                <IonSlides>
                    <IonSlide>
                        <IonItem>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <label for='uploadTemplate'>Upload Invoice Template </label>
                                    <input id='uploadTemplate' type='file' name='xMerchantInvoiceTemplate' accept="image/*" onChange={(e) => invoiceTemplateHandler(e)}></input>
                                <label for='noAttachment'>No Attachment</label>
                                    <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => invoiceTemplateHandler(e)}></input>
                            </form>   
                        </IonItem>
                        <IonButton onClick={uploadTemplate}> Submit </IonButton>                         
                    </IonSlide>
                </IonSlides>
                <IonButton onClick={closeModalHandler}>Cancel </IonButton>
            </IonModal>) : null}
        </React.Fragment>
    )
}